module.exports = __webpack_public_path__ + "media/images/sp/staffs/mv_photographer-606675c97dc889b5a32d57fad3ff9181.webp";